export default "__VITE_ASSET__CAasKDMa__"